import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-shell',
  templateUrl: './payment-shell.component.html',
  styleUrls: ['./payment-shell.component.less'],
  standalone: false,
})
export class PaymentShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
